var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"hint":"Enviar instruções de alteração de senha","icon":"","flat":"","loading":_vm.loading},on:{"click":_vm.sentResetPasswordInstruction}},[_c('v-icon',{attrs:{"small":"","medium":""}},[_vm._v("mdi-refresh")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }